const tabletBreakpoint = 1101;
const initializedSections = new WeakSet();

const initTouchLayouts = (scope = document) => {
  const sections = scope.matches?.('.touch-sec')
    ? [scope]
    : scope.querySelectorAll('.touch-sec');

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    const leftColumn = section.querySelector('.touch-sec__left');
    const bottomContent = section.querySelector('.touch-sec__content--bottom');
    const form = section.querySelector('.touch-sec__form');

    if (!leftColumn || !bottomContent || !form || !form.parentNode) {
      return;
    }

    const originalParent = form.parentNode;
    const placeholder = document.createComment('touch-form-placeholder');
    originalParent.insertBefore(placeholder, form);

    let resizeTimeout = null;
    let frameId = null;

    const syncLayout = () => {
      frameId = null;

      if (window.innerWidth >= tabletBreakpoint) {
        if (form.parentNode !== originalParent) {
          originalParent.insertBefore(form, placeholder.nextSibling);
        }

        return;
      }

      if (form.parentNode !== leftColumn || form.nextElementSibling !== bottomContent) {
        bottomContent.before(form);
      }
    };

    const scheduleSync = () => {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }

      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;

        if (frameId !== null) {
          return;
        }

        frameId = window.requestAnimationFrame(syncLayout);
      }, 120);
    };

    window.addEventListener('resize', scheduleSync, { passive: true });
    syncLayout();
    initializedSections.add(section);
  });
};

initTouchLayouts();
window.initTouchLayouts = initTouchLayouts;
